import React from "react";
import { bindActionCreators } from "redux";
import Confirmation from "./component";
import withReducer from "../../../components/shared/with-reducer";
import injectableReducers from "./injectable";
import { fetchFAQ } from "./actions";

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchFAQConnect: fetchFAQ
}, dispatch);

export default withReducer(injectableReducers)(() => ({}), mapDispatchToProps)(Confirmation);
